import { safeUrl } from './editor/bookmarks';

/**
 * The few Markdown rules release notes use, parsed into plain data the templates draw (nothing is
 * ever inserted as HTML, so text from a server cannot bring markup or scripts): paragraphs, "- " lists,
 * "## " headings, **bold**, `code` and [links](https://…) — only http(s) and mailto links stay links.
 */
export type Inline = { k: 't' | 'b' | 'c'; s: string } | { k: 'a'; s: string; href: string };
export type Block = { t: 'h'; text: Inline[] } | { t: 'p'; text: Inline[] } | { t: 'ul'; items: Inline[][] };

export function parseInline(src: string): Inline[] {
  const out: Inline[] = [];
  const re = /\*\*(.+?)\*\*|`([^`]+)`|\[([^\]]+)\]\(([^)\s]+)\)/g;
  let at = 0;
  for (let m = re.exec(src); m; m = re.exec(src)) {
    if (m.index > at) out.push({ k: 't', s: src.slice(at, m.index) });
    if (m[1] !== undefined) out.push({ k: 'b', s: m[1] });
    else if (m[2] !== undefined) out.push({ k: 'c', s: m[2] });
    else {
      const href = safeUrl(m[4]);
      if (href && /^(https?:|mailto:)/.test(href)) out.push({ k: 'a', s: m[3], href });
      else out.push({ k: 't', s: m[3] });
    }
    at = m.index + m[0].length;
  }
  if (at < src.length) out.push({ k: 't', s: src.slice(at) });
  return out;
}

export function parseBlocks(src: string): Block[] {
  const out: Block[] = [];
  let para: string[] = [];
  const flush = (): void => {
    if (para.length) out.push({ t: 'p', text: parseInline(para.join(' ')) });
    para = [];
  };
  for (const raw of src.replace(/\r/g, '').split('\n')) {
    const line = raw.trim();
    if (!line) {
      flush();
      continue;
    }
    const head = /^#{1,3}\s+(.*)$/.exec(line);
    const item = /^[-*]\s+(.*)$/.exec(line);
    if (head) {
      flush();
      out.push({ t: 'h', text: parseInline(head[1]) });
    } else if (item) {
      flush();
      const last = out[out.length - 1];
      if (last?.t === 'ul') last.items.push(parseInline(item[1]));
      else out.push({ t: 'ul', items: [parseInline(item[1])] });
    } else para.push(line);
  }
  flush();
  return out;
}
